import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "7", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "22", x2: "16", y1: "11", y2: "11", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UserMinus";
const UserMinus = memo(themed(Icon));
export {
  UserMinus
};
//# sourceMappingURL=user-minus.js.map
